export class Controller {

    /** @ngInject */
    constructor($state, GroupsResource) {
        this.$state = $state;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        // this.activeAccounts = this.connectionDetails.activeAccounts;
        // this.pendingAccounts = this.connectionDetails.pendingAccounts;
        // this.allAccounts = this.activeAccounts + this.pendingAccounts;
        this.file = null;
        this.verificationTypes = [
            {name: 'USER', selected: true},
            {name: 'ADMIN', selected: true},
        ];
    }

    selectCsv(csvType) {
        document.querySelector(`[ng-change*="${csvType}"]`).click();
    }

    uploadCsv(csvType) {
        const verificationTypes = this.verificationTypes
            .filter((verificationType) => verificationType.selected)
            .map((verificationType) => verificationType.name);

        this.GroupsResource
            .userVerification(
                this.companyId,
                this.groupId,
                verificationTypes,
                csvType,
                this.file,
            )
            .then(({importedUsers}) => {
                this.$state.go('^.bulk-verification-result', {importedUsers}, {reload: '^'});
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/bulk-verification-csv/bulk-verification-csv.controller.js